import { Container } from "@/components";
import { ESize } from "@/interfaces/enums";
import { Button } from "@netfront/ui-library";

export const LandingBanner = () => {
  return(
    <section className='relative overflow-hidden'>
      <img
        alt="Girl smiling at camera"
        className="lg:none"
        src="/images/homepage-banner.jpg"  
      />
      <Container additionalClassNames="index-1 relative" size={ESize.LG}>
        <div className="flex flex-wrap -mx-8">
          <div className="w-full lg:w-1/2 p-8 py-16 lg:py-32">
            <div className='relative bg-circle'>
              <div className="relative index-1 flex flex-col items-center w-4/5 mr-auto lg:mr-auto lg:mt-112 text-center lg:items-start lg:text-left lg:mt-0 xl:mr-auto ">
                <img src="/images/big-six-icon.svg" className='max-w-24 mb-6' alt="Big six" />
                <span className='h4 color-green-500 text-uppercase'>Welcome</span>
                <h1 className='mb-0'>Parents & Teens</h1>
                <hr className='mt-4 lg:ml-0 mb-6 w-24' />
                <h2 className='h3 mb-4'>What is the Health4Life Parents & Teens study?</h2>
                <p className='mb-8 h5 weight-400'>
                  'Health4Life Parents and Teens' is an engaging online program that aims to improve teenagers' health, with parental support, in the 'Big 6' health domains: sleep, excessive screen use, healthy eating, exercise, vaping/smoking, and alcohol use. It includes 6 PDHPE curriculum-aligned modules, delivered by teachers. Parents complete a brief online program at home. This program was developed by researchers at University of Sydney, with parents and teens in the community. Read below for details.
                </p>
                <Button
                  additionalClassNames="c-button--xl"
                  linkButton={{ id: 'register', url: '#express-interest-form' }}
                  text="Express interest in participating"
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <div className="bg-homepage-banner"></div>
    </section>
  )
};